import { z } from 'zod'

/**
 * `GET /api/v1/health` — the uptime monitor's contract (tech stack spec
 * §3's "returns 200 and confirms DB connectivity"). The first schema this
 * package ever had; every other route's schema followed the same pattern.
 */
export const healthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  version: z.string(),
  checkedAt: z.string(),
  checks: z.object({
    database: z.enum(['ok', 'unreachable']),
  }),
})
export type HealthResponse = z.infer<typeof healthResponseSchema>
